import { useMemo, useState } from 'react';
import html2canvas from 'html2canvas';

const useScreenCapture = () => {
  const [screenshot, setScreenshot] = useState();
  const capture = async (element, { onCapture = () => {} }) => {
    let canvas = document.createElement('canvas');
    const width = element?.videoWidth ?? window.innerWidth;
    const height = element?.videoHeight ?? window.innerHeight;
    const willCapturedElement = element ?? document.body;
    canvas.width = width;
    canvas.height = height;
    try {
      canvas.getContext('2d').drawImage(willCapturedElement, 0, 0, width, height);
    } catch (error) {
      canvas = await html2canvas(willCapturedElement);
    }
    canvas.toBlob((blob) => {
      const _screenshot = {
        source: canvas.toDataURL(),
        file: blob,
        name: 'screenshot.png',
        type: 'image/png',
      };
      onCapture({ screenshot: _screenshot });
      setScreenshot(_screenshot);
    });
  };
  return useMemo(() => [screenshot, capture], [screenshot]);
};

export default useScreenCapture;
